// extracted by mini-css-extract-plugin
module.exports = {"root":"_1BY_i","from":"_3VolL","old":"f7mVb","icon":"jD8uV","to":"_15aBz"};